import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {compose} from "redux";
import {requestArticles, setCurrentPage} from '../../redux/articles-reducer';
import ArticlesContent from './ArticlesContent';
import {getPageFromLocation, pushPage} from "../../shared/pagination";

class ArticlesContentContainer extends React.Component {

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.load();
        }
    }

    load() {
        this.props.requestArticles(getPageFromLocation(this.props.location), this.props.pageSize);
    }

    onPageChanged = (pageNumber) => {
        pushPage(this.props.history, this.props.location, pageNumber);
    }

    render() {
        return <ArticlesContent
            totalArticlesCount={this.props.totalArticlesCount}
            pageSize={this.props.pageSize}
            currentPage={this.props.currentPage}
            onPageChanged={this.onPageChanged}
            articles={this.props.articles}
            loading={this.props.isFetching}
        />
    }
}

let mapStateToProps = (state) => {
    return {
        totalArticlesCount: state.articlesPage.totalArticlesCount,
        pageSize: state.articlesPage.pageSize,
        currentPage: state.articlesPage.currentPage,
        articles:  state.articlesPage.articles,
        isFetching: state.articlesPage.isFetching
    }
}

export default compose(
    connect(mapStateToProps, {setCurrentPage, requestArticles}),
    withRouter
)(ArticlesContentContainer);
